import React from 'react'
import { AutomationId } from 'utils/automationUtil'
import Tag from '../Tag'

type TagGroupProps = {
  tags: string[]
}

const TagGroup = ({ tags }: TagGroupProps) => (
  <>
    {tags.map((tag, index) => (
      <div data-testid={`${AutomationId.soundbiteDefaultFrame.vocTag}-${index}`}>
        <Tag text={tag} key={tag} />
      </div>
    ))}
  </>
)

export default TagGroup
